import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { Button, Col, Row } from "reactstrap";
import Layout from "../components/layout";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const EventPost = ({data}: any) => {
  const post = data.allContentfulEventPost.edges[0].node
  const {title, shortDescription, linkOnly, externalLink, eventStart, eventEnd, displayImage, details} = post;
  const options = {
    weekDay: "long",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit"
  } as any;
  const startDate = new Date(eventStart).toLocaleString('en-US', options);
  const endDate = new Date(eventEnd).toLocaleString('en-US', options);

  return (
    <Layout>
      <div className="post-container">
        <Row>
          <Col md="8" sm="8">
            <h1>{title}</h1>
            {eventStart && <small>{startDate}</small>} 
            {eventEnd && !compareDate(eventStart, eventEnd) && <small> - {endDate}</small>}
            {eventEnd && compareDate(eventStart, eventEnd) && <small> - {new Date(eventEnd).toLocaleTimeString('en-us', {hour:'numeric', minute:'2-digit'})}</small>}
          </Col>
        </Row>
        {displayImage &&
          <Row>
            <Col md={4} sm={12}>
              <GatsbyImage className="event-img" image={displayImage.gatsbyImageData} alt={title}></GatsbyImage>
              {externalLink &&
              <Row>
                <a href={externalLink.externalLink} target="_blank" className="event-register-link">
                  <Button variant="link" size="lg" className="event-register-btn">Register</Button>
                </a>
              </Row>
            }
            </Col>
            <Col md={8} sm={12}>
              <Row>
                {documentToReactComponents(JSON.parse(details.raw))}
              </Row>
            </Col>
          </Row>
        }
        {!displayImage &&
          <Row>
           <Col>
            {DisplayContent()}
           </Col> 
          </Row>
        }
      </div>
    </Layout>
  )

  function DisplayContent() {
    return (
      <Row>
        {externalLink &&
          <Row>
            <a href={externalLink.externalLink}><Button variant="link" size="lg" className="event-register-btn">Register</Button></a>
          </Row>
        }
        <Row>
          {documentToReactComponents(JSON.parse(details.raw))}
        </Row>
      </Row>
    );
  }

  function compareDate(start: any, end: any): boolean{
    const startDate = new Date(start);
    const endDate = new Date(end);
  
    return startDate.getMonth() === endDate.getMonth() 
    && startDate.getDate() === endDate.getDate() 
    && startDate.getFullYear() === endDate.getFullYear();
  }
}


export default EventPost

export const query = graphql`
  query EventQuery($slug: String!) {
    allContentfulEventPost(filter: {fields: {slug: {eq: $slug}}}) {
      edges {
        node {
          title
          shortDescription {
            shortDescription
          }
          linkOnly
          externalLink {
            externalLink
          }
          eventStart
          eventEnd
          displayImage {
            gatsbyImageData
          }
          details {
            raw
          }
        }
      }
    }
  }
`

function DisplayContent(linkOnly: any, externalLink: any, details: any) {
  throw new Error("Function not implemented.");
}
